//npm packages
import React, { memo } from 'react';
import {
  Col,
  Form,
  Row,
  Card,
  CardBody,
  CardHeader,
  Label,
  Button
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import {
  faSave,
  faBackspace,
  faSyncAlt,
  faHistory,
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import { reset } from 'redux-form';

//helper
import strings from '../../globalization';

export default memo(props => {
  const {
      isDark,
      onSubmit,
      handleSubmit,
      title,
      subTitle,
      pristine,
      submitting,
      children,
      shouldGoBack,
      actionInfo,
      dispatch,
      history,
      disableReset,
      advanceButtons,
      FormButtons,
      onFormCancel,
      disableCancel = false,
      disablePristine = false,
      hideSave = false,
      showAdvanceButton = true
    } = props,
    { params } = props.match || {};
  const historyDisable = params.id ? params.id.toLowerCase() === 'new' : true;
  const onCancel = () => {
    const { action, actionName } = actionInfo;
    dispatch(action(null, { type: `${actionName}_RESET` }));
    const cancel = onFormCancel ?? history.goBack;
    cancel();
  };
  const onReset = () => {
    dispatch(reset(props.form));
  };
  const onHistory = () => {
    let id = params.id;
    history.push({ pathname: `/history/${id}`, skip: true });
  };
  if (shouldGoBack) {
    const { action, actionName } = actionInfo;
    dispatch(action(null, { type: `${actionName}_RESET` }));
    history.goBack();
  }

  return (
    <Card className={classNames('custom-card', { 'custom-card-dark': isDark })}>
      <CardHeader
        className={classNames('custom-header', {
          'custom-header-dark': isDark
        })}
      >
        <Row>
          <Col sm="12" md="12" lg="12">
            <Row>
              <Col sm="10" md="10" lg="10">
                <Label className="text-white break-word">
                  <h4>
                    {title} {subTitle && `- ${subTitle}`}
                  </h4>
                </Label>
              </Col>
              {showAdvanceButton && (
                <Col sm="2" md="2" lg="2" className={'advance-buttons'}>
                  {advanceButtons}
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <Form
          onSubmit={handleSubmit(onSubmit)}
          className={classNames('text-black', { 'text-white': isDark })}
        >
          <Row sm="12" md="12" lg="12">
            {children}
          </Row>
          <Row sm="12" md="12" lg="12" className="mt-4">
            <Col>
              {!hideSave && (
                <Button
                  title={props.saveText || strings.Save}
                  type="submit"
                  disabled={
                    disablePristine ? submitting : submitting || pristine
                  }
                  color="primary"
                >
                  <FontAwesomeIcon icon={faSave} />{' '}
                  {props.saveText || strings.Save}
                </Button>
              )}{' '}
              {!disableCancel && (
                <Button
                  title={strings.Cancel}
                  type="button"
                  color="secondary"
                  onClick={props.onCancel || onCancel}
                >
                  {' '}
                  <FontAwesomeIcon icon={faTimes} /> {strings.Cancel}
                </Button>
              )}{' '}
              {!disableReset && (
                <Button
                  title={strings.Reset}
                  type="button"
                  color="info"
                  onClick={onReset}
                >
                  {' '}
                  <FontAwesomeIcon icon={faSyncAlt} /> {strings.Reset}
                </Button>
              )}{' '}
              {!historyDisable && (
                <Button
                  title={strings.History}
                  type="button"
                  color="primary"
                  onClick={onHistory}
                >
                  {' '}
                  <FontAwesomeIcon icon={faHistory} /> {strings.History}
                </Button>
              )}{' '}
              {FormButtons}
            </Col>
          </Row>
        </Form>
      </CardBody>
    </Card>
  );
});
